import Resource from "../base/resource"

class Viewpoint extends Resource {
    id;
    position;
    quaternion;
    resourceId;
    viewpointObj;

    constructor(props) {
        super(props);
        this.id = props.id;
        this.position = props.position;
        this.quaternion = props.quaternion;
        this.resourceId = props.resourceId;
    }

    async load(onLoadCallback) {
        if (wv.effectController.stoppedTrainingId === TrainingTreeController._trainingFeature.getActiveTraining()?.id) {
            return;
        }
        if (!this.resourceId) {
            onLoadCallback(1);
            return;
        }
        this.viewpointObj = await ViewPointManager.getViewpointDataById(this.resourceId);
        onLoadCallback(1);
    }

    getDefaultState() {
        return {};
    }
}

export default Viewpoint;